const convertAttributeToLowerCase = (attribute)=>{
    if (!attribute) {
        return '';
    }
    return Array.isArray(attribute) ? attribute.join().toLowerCase() : attribute.toLowerCase();
};
const calcPrice = (centAmount)=>{
    const price = !isNaN(centAmount) ? (centAmount / 100).toFixed(2).toString() : '0.00';
    if (price === '0') {
        return '0.00';
    }
    return price;
};
const createPriceSpecification = (lineItem)=>{
    const { unit  } = lineItem.price;
    return {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: String(calcPrice(unit.gross)),
        priceCurrency: lineItem.currency,
        validFrom: lineItem.discount.validFrom,
        validThrough: lineItem.discount.validUntil,
        valueAddedTaxIncluded: true,
        priceComponent: [
            {
                '@type': 'UnitPriceSpecification',
                name: 'Price excluding VAT',
                price: String(calcPrice(unit.net)),
                valueAddedTaxIncluded: false
            },
            {
                '@type': 'UnitPriceSpecification',
                name: 'VAT',
                price: String(calcPrice(unit.taxAmount)),
                valueAddedTaxIncluded: true
            }, 
        ]
    };
};
const createOfferObject = (lineItem)=>{
    return {
        '@type': 'Offer',
        includesObject: {
            '@type': 'TypeAndQuantityNode',
            amountOfThisGood: lineItem.quantity || 1
        },
        priceSpecification: createPriceSpecification(lineItem)
    };
};
const createProductObject = (lineItem)=>{
    let url = window.location && window.location.origin || '';
    if (lineItem.productUrl) {
        url += lineItem.productUrl;
    }
    if (lineItem.type === 'prescription-glasses') {
        const { frame , name  } = lineItem;
        const { brand , productId , sku  } = frame;
        return {
            '@type': 'Product',
            '@id': `${url}#product`,
            category: 'Optical',
            url,
            brand: brand.name,
            name,
            sku,
            gtin13: sku,
            productID: productId,
            offers: [
                createOfferObject(lineItem)
            ]
        };
    }
    const { name , sku , productId , type , brand  } = lineItem;
    const frame = lineItem.type === 'sunglasses' ? lineItem.frame : null;
    return {
        '@type': 'Product',
        '@id': `${url}#product`,
        url,
        model: convertAttributeToLowerCase(frame === null || frame === void 0 ? void 0 : frame.frameShape),
        name,
        productID: productId,
        gtin13: sku,
        category: type,
        brand: brand.name,
        material: convertAttributeToLowerCase(frame === null || frame === void 0 ? void 0 : frame.frameMaterial),
        color: convertAttributeToLowerCase(frame === null || frame === void 0 ? void 0 : frame.frameColor),
        offers: [
            createOfferObject(lineItem)
        ]
    };
};

export { createProductObject };
//# sourceMappingURL=structured-data-mapper.js.map
